import mainFeatureSlide from './mainFeatureSlide.js';

export default function () {
  const widgetName = 'cardWidgetVideo';
  const widgetOpts = cardWidgetVideoOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (widgetData) {

      function customVimeoWidget() {
        $(`#${widgetName} .card-widget-item`).each(function (x) {

          let vimeoURLAttr = $(widgetData.items[x].Description).find('iframe').attr('src');
          $(this).find('.card-widget-description iframe').attr('src', `${vimeoURLAttr}&background=1`);
          $(this).find('.card-widget-title').remove();
          $(this).find('.buttonwrap').remove();
        })

        if (widgetData.items.length === 0) {
          $(`#${widgetName}`).remove();
          mainFeatureSlide();

        } else {
          $('#mainFeatureSlideShow').remove();
        }

      }
      customVimeoWidget()

    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [],
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false,
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev', 'Next'],
      nav: true
    },
    textOverImage: true
  });

}